import classNames from 'classnames'
import { useEffect, useRef, useState } from 'react'
import { Cropper, CropperRef, FixedCropper, ImageRestriction } from 'react-advanced-cropper'
import 'react-advanced-cropper/dist/style.css'

import { BUTTON_ROUNDED_STYLES_SM } from '@apps-common/components/elements/button/ButtonRoundedSm'
import { commonIcons } from '@apps-common/config/icons'

export const CropperModal = ({
  onDismiss,
  componentProps
}: {
  onDismiss: (data?: string | null | undefined | number, role?: string) => void
  componentProps: any
}) => {
  const { file, cropDimensions, stencilType } = componentProps
  const cropperRef = useRef<CropperRef>(null)
  const [url, setUrl] = useState<string | null>()

  useEffect(() => {
    const reader = new FileReader()

    reader.onload = () => {
      setTimeout(() => {
        setUrl(reader.result as any)
      }, 50)
    }
    reader.readAsDataURL(file)

    setUrl(URL.createObjectURL(file))
  }, [file])

  const onCrop = () => {
    const cropper = cropperRef.current

    if (cropper) {
      // const coordinates = cropper.getCoordinates()

      const canvas = cropper.getCanvas({
        // minHeight: 0,
        // minWidth: 0,
        height: cropDimensions.height || 400,
        width: cropDimensions.width || 400
      })

      const b64Image = canvas?.toDataURL()

      onDismiss(b64Image, 'confirm')
    }
  }

  const getAspectRatio = () => {
    const { width, height } = cropDimensions || {}

    if (width && height) {
      return width / height
    }

    return 1
  }

  return (
    <div className='w-full h-full flex items-center justify-center bg-transparent p-[1rem]'>
      <div className='relative overflow-hidden flex flex-col w-[100%] h-[60%] md:p-[0px] md:w-[60%] md:h-[50%] lg:w-[700px] lg:h-[700px]'>
        <div className='grow shadow rounded-xl overflow-hidden'>
          {url && (
            <>
              {cropDimensions && (
                <FixedCropper
                  ref={cropperRef as any}
                  src={url}
                  className='cropper min-h-[100%]'
                  stencilProps={{ aspectRatio: getAspectRatio() }}
                  stencilSize={{
                    width: cropDimensions.width || 400,
                    height: cropDimensions.height || 400
                  }}
                  imageRestriction={ImageRestriction.stencil}
                />
              )}
              {!cropDimensions && <Cropper ref={cropperRef as any} src={url} className='cropper grow min-h-[100%]' />}
            </>
          )}
        </div>
        <div className='flex items-center justify-center gap-4 w-full px-2 py-4 bg-transparent'>
          <button type='button' className={classNames(BUTTON_ROUNDED_STYLES_SM, 'action-success md:grow-0')} onClick={() => onCrop()}>
            Crop <commonIcons.crop />
          </button>
          <button
            type='button'
            className={classNames(BUTTON_ROUNDED_STYLES_SM, 'action-neutral md:grow-0')}
            onClick={() => onDismiss(null, 'cancel')}
          >
            Cancel <commonIcons.close />
          </button>
        </div>
      </div>
    </div>
  )
}
